import { useToast } from 'vue-toastification';
import toastPending from '@/components/toast-pending/toast-pending.vue';
import notify from '@/store/notify/notify';
const myToast = {
    startPending: (props, paramsForSaving) => {
        const toast = useToast();
        const toastId = toast({ component: toastPending, props });
        if (paramsForSaving && paramsForSaving.isSave && props && props.hash) {
            myToast.save({
                type: paramsForSaving.type,
                hash: props.hash,
                text: props && props.text,
                link: props && props.link,
                rpcUrl: paramsForSaving.rpcUrl,
                toastId,
                detailed: {
                    default: paramsForSaving.defaultDetailed,
                },
            });
        }
        return toastId;
    },
    finishPending: (toastId, hash) => {
        notify.hide.withMemoryErasure(toastId, hash);
    },
    success: () => {
        const toast = useToast();
        toast.success('Transaction complete');
    },
    error: () => {
        const toast = useToast();
        toast.error('Something went wrong');
    },
    save: notify.actions.save,
    init: notify.actions.init,
};
export default myToast;
